import qs from 'qs';
import { core_apimessages_Money as Money } from '@reverbdotcom/commons/src/gql/graphql';
import { Paths } from '../components/shared/url_helpers';

export const CHECKOUT_ERROR_KEY = 'show_checkout_error';

function currentQuery(): Record<string, unknown> {
  if (typeof window === 'undefined') {
    return {};
  }

  return qs.parse(window.location.search, { ignoreQueryPrefix: true });
}

export function buildCheckoutPaths(checkoutId: string, query: Record<string, unknown> = currentQuery()) {
  // qs.parse can produce arrays or nested objects for a key; only a plain
  // string is meaningful here.
  const _reverb_app = typeof query._reverb_app === 'string' ? query._reverb_app : undefined;

  function show({ showCheckoutError }: { showCheckoutError?: boolean } = {}) {
    return Paths.checkoutShow.expand({
      checkoutId,
      _reverb_app,
      [CHECKOUT_ERROR_KEY]: showCheckoutError,
    });
  }

  function review({ token }) {
    return Paths.checkoutShow.expand({
      checkoutId,
      _reverb_app,
      step: 'review',
      token,
    });
  }

  function paymentInProgress() {
    return Paths.checkoutPaymentInProgress.expand({ checkoutId, _reverb_app });
  }

  function redirectReturn({ displayedAmountOwed }: { displayedAmountOwed: Pick<Money, 'amountCents' | 'currency'> }) {
    return Paths.checkoutRedirectReturn.expand({
      checkoutId,
      _reverb_app,
      displayed_amount_owed_cents: displayedAmountOwed.amountCents,
      displayed_amount_owed_currency: displayedAmountOwed.currency,
    });
  }

  return {
    show,
    review,
    redirectReturn,
    paymentInProgress,
  };
}
